<div *ngIf="validationErrors && validationErrors.length > 0">
  <h3>Please fix the following issues:</h3>

  <div *ngFor="let error of validationErrors">
    {{ error.fieldName }}: {{ error?.displayMessage }}
    <span *ngIf="!error.displayMessage" role="alert">{{ error.message }}</span>
  </div>
</div>
